import { render, staticRenderFns } from "./OrganismRequestOfferModal.vue?vue&type=template&id=36329b4d&scoped=true&"
import script from "./OrganismRequestOfferModal.vue?vue&type=script&lang=js&"
export * from "./OrganismRequestOfferModal.vue?vue&type=script&lang=js&"
import style0 from "./OrganismRequestOfferModal.vue?vue&type=style&index=0&id=36329b4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36329b4d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectMoleculeRequestOffer: require('/app/components/molecules/project/MoleculeRequestOffer.vue').default,MoleculesProjectMoleculeSendRequest: require('/app/components/molecules/project/MoleculeSendRequest.vue').default})
